import React from 'react';
import getTranslationData from '../../TranslationUtility/TranslationUtility';

const NonLoginModal = ({ show=true, onConfirm }) => {
  const translation=getTranslationData();
  if (!show) return null;

  return (
    <div className="redirect-overlay">
      <div className="redirect-modal">
        <h3 className="redirect-title">
         {translation?.redirecting_text}
        </h3>

        <p className="redirect-text">{translation?.confirm_process}</p>

        <button className="confirm-btn" onClick={onConfirm}>
          {translation?.confirm_text}
        </button>
      </div>
    </div>
  );
}

export default NonLoginModal;
